import React from "react";
import "./radomZaufaniePL";
const ZaufanieRadom: React.FC = () => {
  return (
    <div>
      <div id="sff_127__widget-container"></div>
    </div>
  );
};

export default ZaufanieRadom;
